import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import {store} from "./StandAloneDbotStore"
import {StandaloneDbot} from "./StandaloneDbot";



ReactDOM.render(
    <Provider store={store}>
        <StandaloneDbot/>
    </Provider>
    ,
    document.getElementById('root')
);